import Vue from 'vue'
import * as types from './mutation-types'

const namespaced = true

const initialState = {
  houseList: [],
  senateList: []
}

const mutations = {
  [types.PUT_HOUSE_LANDING_MODELS] (state, models) {
    state.houseList = models.map(model => ({
      ...model,
      chamber: model.election.chamber
    }))
  },
  [types.PUT_SENATE_LANDING_MODELS] (state, models) {
    state.senateList = models.map(model => ({
      ...model,
      chamber: model.election.chamber
    }))
  },
  [types.CLEAR_MODELS] (state, item) {
    Vue.set(state, item, [])
  }
}

const actions = {
  houseList (context, params) {
    fetch(`https://forecasting-data.decisiondeskhq.com/2018/prod/house/${params.date}.json`)
      .then(response => response.json())
      .then(data => {
        context.commit(types.CLEAR_MODELS, 'houseList')
        context.commit(types.PUT_HOUSE_LANDING_MODELS, data)
        return data
      })
      .catch(error => console.error(error))
  },
  senateList (context, params) {
    fetch(`https://forecasting-data.decisiondeskhq.com/2018/prod/senate/${params.date}.json`)
      .then(response => response.json())
      .then(data => {
        context.commit(types.CLEAR_MODELS, 'senateList')
        context.commit(types.PUT_SENATE_LANDING_MODELS, data)
        return data
      })
      .catch(error => console.error(error))
  }
}

const getters = {
  houseList (state) {
    return state.houseList
  },
  senateList (state) {
    return state.senateList
  }
}

export default {
  namespaced,
  state: initialState,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/modules/landing-models.js